import { createFileRoute } from '@tanstack/react-router'
import { Screen } from '@/components/app/screen'
import { ScreenHeader } from '@/components/app/screen-header'
import { useLogout } from '@/hooks/use-logout'

export const Route = createFileRoute('/_fidele/mon-profil/')({
  component: MemberProfileScreen,
})

function MemberProfileScreen() {
  const logout = useLogout()

  return (
    <Screen withTabBar>
      <ScreenHeader title="Mon profil" />
      <div className="px-5">
        <p className="text-[14px] leading-relaxed text-steel">
          Vos informations sont gérées par le secrétariat de votre église.
        </p>
        <button
          type="button"
          onClick={logout}
          className="mt-8 w-full rounded-[14px] border border-navy-800 py-3.5 text-[15px] font-semibold text-danger"
        >
          Se déconnecter
        </button>
      </div>
    </Screen>
  )
}
